import $ from 'jquery';

function init () {
  $('.hero-lander__content__toggle').click(() => {
    $('.hero-lander__content').toggleClass('open');
  })
}

export default { init };
export { init };
